import React from 'react'
import BoxItem1 from "./BoxItem1"
import BoxItem2 from "./BoxItem2"
import BoxItem3 from "./BoxItem3"
import BoxItem4 from "./BoxItem4"
import {Spin} from "antd"

const BoxOverview = (props) => {
    const {balanceOverview, loading, error} = props
    const {balance, id, totalAdd, totalSub} = balanceOverview

    const formatNumber = function (number, n, x, s, c) {
        let re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
            num = number.toFixed(Math.max(0, ~~n));

        return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ','));
    };

    return <Spin spinning={loading && Object.keys(balanceOverview).length === 0} tip="Đang lấy dữ liệu...">
        {error && <div className="text-danger">{error}</div>}
        <div className="BoxOverview">
            <BoxItem1 number={balance && formatNumber(balance, 0, 3, '.', ',')} title="Số dư"/>
            <BoxItem2 number={totalAdd && formatNumber(totalAdd, 0, 3, '.', ',')} title="Tổng nạp"/>
            <BoxItem3 number={totalSub && formatNumber(totalSub, 0, 3, '.', ',')} title="Tổng chi"/>
            <BoxItem4 number={id || ""} title="Gói"/>
        </div>
    </Spin>
}

export default BoxOverview
